export default "__VITE_ASSET__DsftSiy$__"